<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ data.isEdit ? 'Edit' : 'Add' }} Site Data Entry {{text}}
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <div>
    <table style="text-align:center; margin: 0 auto;">
      <tr>
        <td style="text-align: left;"><b>Name:</b></td>
        <td style="text-align: left;">{{data.userName}}</td>
      </tr>
      <tr>
        <td style="text-align: left;"><b>Date Captured:</b></td>
        <td>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="picker" [(ngModel)]="data.dateCaptured" #dcctrl="ngModel" required (dateChange)="onDateCapturedChange($event.value)"
              [disabled]="data.isEdit" placeholder="Choose a date" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="dcctrl.invalid"></mat-error>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td style="text-align: left;"><b>Site Name:</b></td>
        <td style="text-align: left;">{{data.siteName}}</td>
      </tr>
    </table>
  </div>
  <form [formGroup]="sdcForm">
    <mat-tab-group class="flex-grow h-full" [selectedIndex]="selectedTabIndex()" (selectedIndexChange)="selectedTabIndex.set($event)">
<!--      
      <mat-tab label="General Data">
        <div class="tabsHeight"> -->

          <!-- ORA Downtime Section -->
          <!-- <div class="">
            <div class="form-container">
              <mat-slide-toggle formControlName="isOraDowntime" color="primary">ORA Downtime</mat-slide-toggle>
              <mat-form-field appearance="outline" class="validation-field">
                <mat-label>ORA Downtime Hours</mat-label>
                <input matInput type="text" formControlName="oraDowntimeHours" step="1" (input)="roundOff($event, 24, 0, 0, 'oraDowntimeHours')">
                @if (sdcForm.get('oraDowntimeHours')?.hasError('max')) {
                  <mat-error>Value cannot be greater than 24</mat-error>
                }
              </mat-form-field>
            </div>
            <hr />
            <p style="font-style:italic;color: black;text-align: left;">
              <b> If previous day gas production is under proforma, please select and assign a ranking from the following selections</b>
            </p>
            <br />
            <p style="color: black;text-align: left;">
              Previous day's Gas Production: <b id="prevGas"> {{ previousDayGasProduction() }}</b>
            </p>
            <div class="form-container">
              @for (field of EQUIPMENT_FIELD_MAP; track field.typeName) {
                <mat-form-field appearance="outline">
                  <mat-label>{{ field.label }}</mat-label>
                  <mat-select multiple [value]="getSelectedIdsForType(field.typeName)"
                    (selectionChange)="onEquipmentSelectionChange(field.typeName, $event.value)">
                    <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                      <input #siteSearchInput matInput placeholder="Search ..." (input)="filterequipment($event, field.typeName)"
                        class="mat-select-search-input" aria-label="Search " (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation();" />
                      <mat-icon class="mat-select-search-icon">search</mat-icon>
                    </div>
                    @for (item of filteredEquipmentGroups()[field.typeName] || []; track item.id) {
                      <mat-option [value]="item.id">
                        {{ item.equipmentValue }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
            <mat-form-field appearance="outline" style="float: left;margin-left: 20px !important;width: 94%;">
              <mat-label>Notes</mat-label>
              <textarea matInput rows="3" formControlName="notes"></textarea>
            </mat-form-field>
          </div>
          <div>
            @if (selectedEquipment().length > 0) {
              <div style="margin-left: 20px;">
                <table class="sequence-table mat-elevation-z2">
                  <thead>
                    <tr>
                      <th>Selected Equipment</th>
                      <th>Downtime in minutes</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (sel of selectedEquipment(); track sel.equipmentId) {
                      <tr>
                        <td>{{ equipmentLabelMap.get(sel.equipmentId) ?? 'Unknown' }}</td>
                        <td>
                          <mat-form-field appearance="outline" class="sequence-input-field"
                            [class.mat-form-field-invalid]="attemptedSave() && !sel.minutes">
                            <input matInput type="text" min="1" max="100" [value]="sel.minutes ?? ''"
                              (input)="onMinutesInput(sel.equipmentId, $event)"
                              placeholder="minutes"
                              (keypress)="onlyIntegers($event)"  required/>
                          </mat-form-field>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div> -->
        <!-- </div>
      </mat-tab> -->

      <!-- DYNAMIC TABS -->
      @for (tab of dynamicTabs(); track tab.id; let i = $index) {
      <mat-tab [label]="tab.tabName">
        <div class="tabsHeight" formArrayName="dynamicData">
          <div [formGroupName]="i">
            <div class="form-container">
              <mat-form-field appearance="outline">
                <mat-label>pH Number</mat-label>
                <input matInput type="text" formControlName="digesterpH" step="0.1" (input)="roundOffDynamic($event, i, 'digesterpH', 9, 1)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>ORP Number</mat-label>
                <input matInput type="text" formControlName="digesterORP" step="0.01" (input)="roundOffDynamic($event, i, 'digesterORP', 99999, 2, true)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Hydrolyzer pH</mat-label>
                <input matInput type="text" formControlName="hydrolyzerpH" step="0.001" (input)="roundOffDynamic($event, i, 'hydrolyzerpH', 9, 1)">
                <mat-error *ngIf="getDynamicTabGroup(i).get('hydrolyzerpH')?.hasError('required')">Required</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Digester pH (Titrator)</mat-label>
                <input matInput type="text" formControlName="digesterpHTitrator" step="0.001" (input)="roundOffDynamic($event, i, 'digesterpHTitrator', 9, 3)">
                <mat-error *ngIf="getDynamicTabGroup(i).get('digesterpHTitrator')?.hasError('required')">Required</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Number of Titrations</mat-label>
                <input matInput type="text" formControlName="numberofTitrations" step="0.001" (input)="roundOffDynamic($event, i, 'numberofTitrations', 99999, 0)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>TIC 1</mat-label>
                <input matInput type="text" formControlName="tic1" (input)="roundOffDynamicAndCalculateTIC($event, i, 'tic1', 99, 3)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>TIC 2</mat-label>
                <input matInput type="text" formControlName="tic2" (input)="roundOffDynamicAndCalculateTIC($event, i, 'tic2', 99.999, 3)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>TIC 3</mat-label>
                <input matInput type="text" formControlName="tic3" (input)="roundOffDynamicAndCalculateTIC($event, i, 'tic3', 99.999, 3)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Average of TIC</mat-label>
                <input matInput type="text" formControlName="averageOfTIC" step="0.001" (input)="roundOffDynamic($event, i, 'averageOfTIC', 99.999, 3)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>TIC</mat-label>
                <input matInput type="text" formControlName="tic" step="0.001" (input)="roundOffDynamic($event, i, 'tic', 99999.999, 3)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>VFA 1</mat-label>
                <input matInput type="text" formControlName="vfa1" (input)="roundOffDynamicAndCalculateVFA($event, i, 'vfa1', 9.999, 3)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>VFA 2</mat-label>
                <input matInput type="text" formControlName="vfa2" (input)="roundOffDynamicAndCalculateVFA($event, i, 'vfa2', 9.999, 3)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>VFA 3</mat-label>
                <input matInput type="text" formControlName="vfa3" (input)="roundOffDynamicAndCalculateVFA($event, i, 'vfa3', 9.999, 3)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Average of VFA</mat-label>
                <input matInput type="text" formControlName="averageOfVFA" step="0.001" (input)="roundOffDynamic($event, i, 'averageOfVFA', 9.999, 3)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>VFA</mat-label>
                <input matInput type="text" formControlName="vfa" step="0.001" (input)="roundOffDynamic($event, i, 'vfa', 999999.999, 3)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Ratio</mat-label>
                <input matInput type="text" formControlName="ratio" step="0.001" (input)="roundOffDynamic($event, i, 'ratio', 999999.99, 2)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Handheld Temperature for AD</mat-label>
                <input matInput type="text" formControlName="handheldTemperatureforAD" step="0.001" (input)="roundOffDynamic($event, i, 'handheldTemperatureforAD', 99999.99, 2)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Handheld CH4 (%)</mat-label>
                <input matInput type="text" formControlName="handheldCH4Percentage" step="0.001" (input)="roundOffDynamic($event, i, 'handheldCH4Percentage', 100, 2)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Handheld CO2 (%)</mat-label>
                <input matInput type="text" formControlName="handheldCO2Percentage" step="0.001" (input)="roundOffDynamic($event, i, 'handheldCO2Percentage', 100, 2)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Handheld O2 (%)</mat-label>
                <input matInput type="text" formControlName="handheldO2Percentage" step="0.001" (input)="roundOffDynamic($event, i, 'handheldO2Percentage', 100, 2)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Handheld H2S (ppm)</mat-label>
                <input matInput type="text" formControlName="handheldH2Sppm" step="0.001" (input)="roundOffDynamic($event, i, 'handheldH2Sppm', 99999.99, 2)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Yesterday Flare Volume (MSCF)</mat-label>
                <input matInput type="text" formControlName="yesterdayFlareVolumeMSCF" step="0.01" (input)="roundOffDynamic($event, i, 'yesterdayFlareVolumeMSCF', 999999.99, 2)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>ORA Slurry TS (%)</mat-label>
                <input matInput type="text" formControlName="oraslurryTS" step="0.01" (input)="roundOffDynamic($event, i, 'oraslurryTS', 100, 2)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>HT2 TS (%)</mat-label>
                <input matInput type="text" formControlName="ht2tS" step="0.01" (input)="roundOffDynamic($event, i, 'ht2tS', 100, 2)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>ORA Slurry TS 2(%)</mat-label>
                <input matInput type="text" formControlName="oraslurryTS_2" step="0.01" (input)="roundOffDynamic($event, i, 'oraslurryTS_2', 100, 2)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>HT2 TS 2(%)</mat-label>
                <input matInput type="text" formControlName="ht2tS_2" step="0.01" (input)="roundOffDynamic($event, i, 'ht2tS_2', 100, 2)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>AD Chlorides (mg/L)</mat-label>
                <input matInput type="text" formControlName="adChlorides" (input)="roundOffDynamic($event, i, 'adChlorides', 99999, 2)">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>HT2 Chlorides (mg/L)</mat-label>
                <input matInput type="text" formControlName="hT2Chlorides" (input)="roundOffDynamic($event, i, 'hT2Chlorides', 99999, 2)">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>AD TS (%)</mat-label>
                <input matInput type="text" formControlName="aDTS" step="0.01" (input)="roundOffDynamic($event, i, 'aDTS', 100, 2)">
              </mat-form-field>
              <mat-slide-toggle formControlName="sphp" color="primary">Did You Properly Store pH Probe When Finished?</mat-slide-toggle>
            </div>
            <mat-form-field appearance="outline" style="float: left;margin-left: 20px !important;width: 92%;">
              <mat-label>Notes</mat-label>
              <textarea matInput rows="3" formControlName="notes"></textarea>
            </mat-form-field>
          </div>
        </div>
      </mat-tab>
      }
    </mat-tab-group>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
  @if(canShowSaveButton()) {
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  }
</mat-dialog-actions>
